import { apiURL } from "../schema/apiURL.js";
import { Item, ParentItem } from "../schema/item.js";
import { getSheetID } from "../sheet.js";
import {
  formatErrorForDisplay,
  isGoogleContentRedirectError,
  parseResponse,
} from "./responseError.js";

export {
  getAll,
  getVerse,
  getVerseOA,
  getMix,
  getPM,
  postCheck,
  postQR,
  postMix,
};

const processError = (error: unknown) => {
  if (isGoogleContentRedirectError(error)) {
    console.warn("Google response redirect failed after API execution:", error);
    return;
  }

  console.error("Error:", error);
  alert(`Error: ${formatErrorForDisplay(error)}`);
};

const apiRequest = async <T>(url: string, options: RequestInit): Promise<T> => {
  try {
    const response = await fetch(url, { ...options, redirect: "follow" });
    return (await parseResponse(response)) as T;
  } catch (error) {
    processError(error);
    throw error;
  }
};

const getAll = async (): Promise<JSON> => {
  // const mockData = await import("../mygitignore-apigetres.json.js");
  // return mockData.default;
  const url = `${apiURL}?sheetID=${getSheetID()}`;
  return apiRequest(url, { method: "GET" });
};

const getVerse = async (): Promise<JSON> => {
  // const mockData = await import("../mygitignore-apigetres.json.js");
  // return mockData.default;
  const url = `${apiURL}?sheetID=${getSheetID()}&method=verse-GET`;
  return apiRequest(url, { method: "GET" });
};

const getVerseOA = async (): Promise<JSON> => {
  const url = `${apiURL}?sheetID=${getSheetID()}&method=verse-oa-GET`;
  return apiRequest(url, { method: "GET" });
};

const getMix = async (): Promise<JSON> => {
  // const mockData = await import("../mygitignore-apigetres.json.js");
  // return mockData.default;
  const url = `${apiURL}?sheetID=${getSheetID()}&method=mix-GET`;
  return apiRequest(url, { method: "GET" });
};

const getPM = async (): Promise<JSON> => {
  // const mockData = await import("../mygitignore-apigetres.json.js");
  // return mockData.default;
  const url = `${apiURL}?sheetID=${getSheetID()}&method=pm-GET`;
  return apiRequest(url, { method: "GET" });
};

const postCheck = async (item: Item, checked: boolean): Promise<object> => {
  const url = apiURL;
  const bodyData = {
    sheetID: getSheetID(),
    method: checked ? "check-POST" : "check-DELETE",
    id: item.itemID,
  };
  return apiRequest(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: JSON.stringify(bodyData),
  });
};

const postQR = async (item: Item, qrData: string): Promise<JSON> => {
  const url = apiURL;
  const bodyData = {
    sheetID: getSheetID(),
    method: "qr-POST",
    id: item.itemID,
    data: qrData,
  };
  // const mockData = new Promise<JSON>((resolve) => {
  //   resolve({ aaa: 123 });
  // });
  // return mockData;
  return apiRequest(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: JSON.stringify(bodyData),
  });
};

const postMix = async (parentItem: ParentItem): Promise<JSON> => {
  const url = apiURL;

  const arrengedItems = parentItem.children.reduce(
    (acc, item) => {
      // すでにキーが存在していなければ空の配列を作成
      if (!acc[item.term]) {
        acc[item.term] = [];
      }
      // 対応する配列に item.id を追加
      acc[item.term].push(item.itemID);
      return acc;
    },
    {} as Record<string, string[]>
  );

  const bodyData = {
    sheetID: getSheetID(),
    method: "mix-local-POST",
    id: crypto.randomUUID(),
    name: JSON.stringify({ name: parentItem.name }),
    items: JSON.stringify(arrengedItems),
    brand: JSON.stringify({ name: parentItem.brand }),
  };
  // const mockData = new Promise<JSON>((resolve) => {
  //   resolve({ aaa: 123 });
  // });
  // return mockData;
  return apiRequest(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: JSON.stringify(bodyData),
  });
};
